import { t } from "../../../i18n";
import { trpc } from "../../../lib/trpc";
import { Button, Dialog, FieldMessage } from "../../ui";
import type { Settlement } from "../types";

interface DeleteSettlementDialogProps {
  settlement: Settlement;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export function DeleteSettlementDialog({
  settlement,
  open,
  onClose,
  onDeleted,
}: DeleteSettlementDialogProps) {
  const utils = trpc.useUtils();
  const remove = trpc.settlement.delete.useMutation({
    onSuccess: () => {
      utils.settlement.list.invalidate({ groupId: settlement.householdId });
      onDeleted();
    },
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t.settlement.deleteDialog.title}
      description={t.settlement.deleteDialog.description(settlement.title)}
      size="sm"
      footer={
        <>
          <Button onClick={onClose}>{t.common.cancel}</Button>
          <Button
            variant="danger"
            iconLeft="trash"
            isLoading={remove.isPending}
            onClick={() => remove.mutate({ settlementId: settlement.id })}
          >
            {t.settlement.deleteDialog.submit}
          </Button>
        </>
      }
    >
      {remove.isError && (
        <FieldMessage tone="error" className="text-sm">
          {remove.error.message}
        </FieldMessage>
      )}
    </Dialog>
  );
}
